import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';

import { hashSettled } from 'rsvp';

import type { Service } from 'webapp-types';

import type BoardsViewBoardController from 'webapp/controllers/boards/view/board';

import type Board from 'webapp/models-custom/board';

export default class BoardsViewBoardRoute extends Route {
	@service('model-manager/boards') declare mmBoardsService: Service.ModelManager.Boards;
	@service('model-manager/templates') declare mmTemplatesService: Service.ModelManager.Templates;
	@service('navigation') declare navigationService: Service.Navigation;

	override beforeModel(): Promise<unknown> {
		const promises: Record<string, Promise<unknown>> = {};

		promises.initialRequests = this.navigationService.initialRequestsPromise;

		promises.accountTemplates = this.mmTemplatesService.requestBoardAccountTemplates();

		return hashSettled(promises);
	}

	override model(params: { board_id?: string }): Board | void {
		let model;

		if (params.board_id) {
			model = this.mmBoardsService.findModel(params.board_id);
		}

		if (!model) {
			this.navigationService.replaceRoute('boards.index');
			return;
		}

		return model;
	}

	override setupController(
		controller: BoardsViewBoardController,
		model: Board,
		transition: Transition,
	): void {
		super.setupController(controller, model, transition);
		controller.activate();
	}
}
